import React from "react";

function Graphics() {
  return <h1>Graphics Pro</h1>;
}

export default Graphics;
